import AgencyHelper from 'features/Agency/agencyHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDateRangePicker, {
    dateFilter,
    getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

AgencyPremiseOrderListFilterView.propTypes = {
    onCancel: PropTypes.func,
    onApply: PropTypes.func,
    initialFilter: PropTypes.object,
};

function AgencyPremiseOrderListFilterView({ onCancel, onApply, closeDropdown, initialFilter }) {
    // MARK: ---- PROPERTIES ----
    const [filterQ, setFilterQ] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const [filterOrderType, setFilterOrderType] = useState('');
    const [filterContractStatus, setFilterContractStatus] = useState('');
    const [filterDateFilter, setFilterDateFilter] = useState(null);
    const [filterFrom, setFilterFrom] = useState('');
    const [filterTo, setFilterTo] = useState('');
    useEffect(() => {
        setFilterQ(initialFilter?.q);
        setFilterStatus(initialFilter?.status);
        setFilterOrderType(initialFilter?.orderType);
        setFilterContractStatus(initialFilter?.contractStatus);
        setFilterDateFilter(initialFilter?.dateFilter);
        setFilterFrom(initialFilter?.from);
        setFilterTo(initialFilter?.to);
    }, [initialFilter]);

    // MARK: ---- METHODS ----
    const handleApplyFilter = () => {
        const newFilter = {
            buyerId: initialFilter?.buyerId ?? '',
            page: 0,
            limit: AppConfigs.defaultPageLimit,
            q: filterQ,
            status: filterStatus,
            orderType: filterOrderType,
            contractStatus: filterContractStatus,
            dateFilter: filterDateFilter,
            from: filterFrom,
            to: filterTo,
        };
        if (onApply) onApply(newFilter);
        if (closeDropdown) closeDropdown();
    };
    const handleClearFilter = () => {
        const newFilter = {
            buyerId: initialFilter?.buyerId ?? '',
            page: 0,
            limit: AppConfigs.defaultPageLimit,
            q: '',
            status: '',
            orderType: '',
            contractStatus: '',
            dateFilter: dateFilter.baMuoiNgayGanNhat,
            from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
            to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
        };
        if (onCancel) onCancel(newFilter);
        if (closeDropdown) closeDropdown();
    };

    return (
        <div className="py-4">
            <div className="row m-0 px-2">
                {/* tim kiem */}
                <div className="col-12 mb-4 px-2">
                    <KTFormSearch
                        name="search_filter"
                        placeholder="Theo mã đơn hàng, người bán hàng/giới thiệu..."
                        value={filterQ}
                        onSubmit={(text) => {
                            setFilterQ(text);
                        }}
                    />
                </div>
                {/* trang thai don hang*/}
                <div className="col-6 mb-4 p-0 px-2">
                    {UIHelper.buildFormLabel('Trạng thái đơn hàng')}
                    <KTBSDropdown
                        name="status_filter"
                        toggleElement={
                            <button
                                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                type="button"
                            >
                                {_.find(AgencyHelper.Data.orderStatusOptions, (item) => item.value === filterStatus)
                                    ?.name ?? 'Tất cả'}
                            </button>
                        }
                        selectedValue={filterStatus}
                        dropdownMenuItems={[
                            { name: 'Tất cả', value: '' },
                            ...AgencyHelper.Data.orderStatusOptions,
                        ]}
                        dropdownMenuClassName="overflow-auto w-100"
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        onChange={(value) => {
                            setFilterStatus(value);
                        }}
                        isDropdownForm={true}
                    />
                </div>
                {/* loc theo trang thai hop dong */}
                <div className="col-6 mb-4 p-0 px-2">
                    {UIHelper.buildFormLabel('Trạng thái hợp đồng')}
                    <KTBSDropdown
                        name="contractStatus_filter"
                        toggleElement={
                            <button
                                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                type="button"
                            >
                                {_.find(AgencyHelper.Data.contractOptions, (item) => item.value === filterContractStatus)
                                    ?.name ?? 'Tất cả'}
                            </button>
                        }
                        selectedValue={filterContractStatus}
                        dropdownMenuItems={[
                            { name: 'Tất cả', value: '' },
                            ...AgencyHelper.Data.contractOptions,
                        ]}
                        dropdownMenuClassName="overflow-auto w-100"
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        onChange={(value) => {
                            setFilterContractStatus(value);
                        }}
                        isDropdownForm={true}
                    />
                </div>
                {/* khoang thoi gian */}
                <div className="col-12 mb-4 p-0 px-2">
                    {UIHelper.buildFormLabel('Khoảng thời gian')}
                    <CustomDateRangePicker
                        inlineMode={true}
                        toggleElementBorderRadius={5}
                        initialValue={filterDateFilter}
                        onPressSave={(selectedValue, startDate, endDate) => {
                            setFilterDateFilter(selectedValue);
                            setFilterFrom(startDate);
                            setFilterTo(endDate);
                        }}
                    />
                </div>
            </div>
            {/* actions */}
            <div
                className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Xóa bộ lọc', handleClearFilter)}
                {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
            </div>
        </div>
    );
}

export default AgencyPremiseOrderListFilterView;
